import { useContext } from "react";

import { Button } from "~/components/Button";
import { authenticationAtom } from "~/modules/authentication/data";
import { signOut } from "~/modules/authentication/services";
import { useAtom } from "~/observers/jotai";

import { subscriptionsCheckoutContext } from "../..";

export const IdentifiedCustomer: React.FC = () => {
	const { handleSetCurrentFrame } = useContext(subscriptionsCheckoutContext);
	const [session] = useAtom(authenticationAtom);

	return (
		<div className="flex flex-col items-center gap-4 py-4">
			<h2 className="text-xl font-semibold">
				Olá, {session?.user.name.split(" ")[0]}
			</h2>
			<div className="h-[1px] bg-slate-300 w-full"></div>
			<p className="text-center">
				Identificamos seu acesso na plataforma. <br /> Iremos vincular esta
				compra à sua conta do GPA Stúdio Pro
			</p>
			<div className="flex gap-3 w-full max-w-[400px] my-2">
				<Button className="flex-1" mode="blank" color="error" onClick={signOut}>
					Trocar Acesso
				</Button>
				<Button
					className="flex-1"
					onClick={() => handleSetCurrentFrame("card")}
				>
					Prosseguir
				</Button>
			</div>
		</div>
	);
};
